module.exports = __webpack_public_path__ + "img/add_user.3d967f10.png";